import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["timeRangeSelector", "displayTimeRange", "startTime", "endTime", "selectorButton"]
  static values = {
    persisted: { type: Boolean, default: false }
  }

  connect() {
    this.updateDisplay()
  }

  dispatchFlashError(message, context = 'Time Range Selection') {
    const event = new CustomEvent('flash:error', {
      detail: { message, context },
      bubbles: true
    })
    this.element.dispatchEvent(event)
  }

  toggleTimeRange() {
    this.timeRangeSelectorTarget.classList.remove("hidden")
  }

  saveTimeRange() {
    const startTime = this.startTimeTarget.value
    const endTime = this.endTimeTarget.value

    if (!startTime || !endTime) {
      this.dispatchFlashError("Start time and End time is required.")
      return
    }

    if (startTime >= endTime) {
      this.dispatchFlashError("End time must be after start time")
      return
    }

    this.updateDisplayContent(startTime, endTime)

    this.timeRangeSelectorTarget.classList.add("hidden")
    this.displayTimeRangeTarget.classList.remove("hidden")
    this.selectorButtonTarget.classList.add("hidden")
  }

  cancelTimeRange() {
    this.timeRangeSelectorTarget.classList.add("hidden")

    if(!this.persistedValue) {
      if (this.hasDisplayTimeRangeTarget) {
        this.displayTimeRangeTarget.classList.add("hidden")
      }
      this.selectorButtonTarget.classList.remove("hidden")
    }

    this.startTimeTarget.value = ""
    this.endTimeTarget.value = ""
  }

  editTimeRange() {
    this.toggleTimeRange()
  }

  updateDisplay() {
    const startTime = this.startTimeTarget.value
    const endTime = this.endTimeTarget.value

    if (startTime && endTime) {
      this.updateDisplayContent(startTime, endTime)
    }
  }

  updateDisplayContent(startTime, endTime) {
    const displaySpan = this.displayTimeRangeTarget.querySelector('span')

    const formattedStart = this.formatTime(startTime)
    const formattedEnd = this.formatTime(endTime)
    displaySpan.textContent = `Time (${formattedStart} to ${formattedEnd})`
  }

  formatTime(time) {
    const [hours, minutes] = time.split(':')
    const hour = parseInt(hours)
    return `${hour}:${minutes}`
  }
}
